export default __webpack_public_path__ + "assets/12f4c786-0bef-4a48-b7c0-eebaa7591688-thai.woff2";